// client/src/api/notificationPreferencesService.js
import flex from './FlexFetch'
import { unwrapStrictData } from './contractUtils'

const preferences_endpoint = '/api/1.0/users/'

/**
 * Get notification preferences for the current user
 * @returns {Promise<Array>} Array of preference objects
 */
async function getPreferences() {
  const response = await flex.flexFetch(
    `${preferences_endpoint}get-notification-preferences`,
    {
      credentials: 'include',
    },
  )
  const data = unwrapStrictData(await flex.handleResponse(response))
  return data.preferences
}

/**
 * Update notification preferences for the current user
 * @param {Array} preferences - Array of { event_type, channel, enabled } objects
 * @returns {Promise<Array>} Updated preferences array
 */
async function updatePreferences(preferences) {
  const response = await flex.flexFetch(
    `${preferences_endpoint}update-notification-preferences`,
    {
      method: 'PUT',
      body: JSON.stringify({ preferences }),
      credentials: 'include',
    },
  )
  const data = unwrapStrictData(await flex.handleResponse(response))
  return data.preferences
}

const NotificationPreferencesService = {
  getPreferences,
  updatePreferences,
}

export default NotificationPreferencesService
